"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendList = void 0;
var solid_ui_1 = require("solid-ui");
var lit_html_1 = require("lit-html");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var baseStyles_1 = require("./baseStyles");
var styles = {
    root: (0, style_map_js_1.styleMap)((0, baseStyles_1.padding)()),
    heading: (0, style_map_js_1.styleMap)((0, baseStyles_1.headingLight)()),
};
var noFriendsFoundMessage = "You have no friends in your list yet";
var FriendList = function (subject, context) { return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  <div style=", ">\n    <h3 style=", ">Friends</h3>\n    ", "\n  </div>\n"], ["\n  <div style=", ">\n    <h3 style=", ">Friends</h3>\n    ", "\n  </div>\n"])), styles.root, styles.heading, createList(subject, context)); };
exports.FriendList = FriendList;
var createList = function (subject, _a) {
    var dom = _a.dom;
    var target = dom.createElement("div");
    solid_ui_1.widgets.attachmentList(dom, subject, target, {
        doc: subject.doc(),
        modify: false,
        predicate: solid_ui_1.ns.foaf("knows"),
        noun: "friend",
    });
    if (target.textContent === "")
        return noFriendsInTheListMessage(dom, noFriendsFoundMessage);
    else
        return target;
};
var noFriendsInTheListMessage = function (dom, message) { return (0, lit_html_1.html)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  <div id=\"no-friends\" style=", ">", "</div>\n"], ["\n  <div id=\"no-friends\" style=", ">", "</div>\n"])), styles.root, message); };
var templateObject_1, templateObject_2;
//# sourceMappingURL=FriendList.js.map